<ng-template #viewerBody>
	<div class="cad-viewer-inner">
		<div class="stp-toolbar">
			<button class="stp-btn" (click)="stpFitToView()" title="Fit to View (F)"><i class="fas fa-compress-arrows-alt"></i></button>
			<button class="stp-btn" (click)="stpResetCamera()" title="Reset Camera"><i class="fas fa-crosshairs"></i></button>
			<button class="stp-btn" [class.active]="stpIsOrthographic" (click)="stpToggleOrthographic()" title="Orthographic / Perspective"><i class="fas fa-cube"></i></button>
			<button class="stp-btn" [class.active]="stpAutoRotate" (click)="stpToggleAutoRotate()" title="Auto Rotate"><i class="fas fa-sync-alt"></i></button>
			<button class="stp-btn" [class.active]="stpWireframe" (click)="stpToggleWireframe()" title="Wireframe Only"><i class="fas fa-border-all"></i></button>
			<button class="stp-btn" [class.active]="stpEdgeOverlay" (click)="stpToggleEdgeOverlay()" title="Solid + Edges"><i class="fas fa-vector-square"></i></button>
			<button class="stp-btn" [class.active]="stpBoundingBoxVisible" (click)="stpToggleBoundingBox()" title="Bounding Box"><i class="fas fa-square"></i></button>
			<button class="stp-btn" (click)="stpCycleColourMode()" title="Colour Mode"><i class="fas fa-palette"></i></button>
			<button class="stp-btn" (click)="stpCycleBackground()" title="Background"><i class="fas fa-adjust"></i></button>
			<button class="stp-btn" [class.active]="stpExploded" (click)="stpToggleExploded()" title="Exploded View"><i class="fas fa-expand-arrows-alt"></i></button>
			<button class="stp-btn" [class.active]="stpSectionVisible" (click)="stpToggleSection()" title="Section Plane"><i class="fas fa-cut"></i></button>
			<button class="stp-btn" [class.active]="stpPartTreeVisible" (click)="stpTogglePartTree()" title="Parts"><i class="fas fa-list"></i></button>
			<button class="stp-btn" [class.active]="stpCompareMode" (click)="stpCompareMode ? clearCompare() : requestCompareFile()" [title]="stpCompareMode ? 'Exit Comparison' : 'Compare Against File'"><i class="fas fa-clone"></i></button>

			<span class="stp-sep"></span>

			<button class="stp-btn" [class.active]="stpMeasureType === 'distance'" (click)="stpSetMeasureType('distance')" title="Measure Distance"><i class="fas fa-ruler"></i></button>
			<button class="stp-btn" [class.active]="stpMeasureType === 'angle'" (click)="stpSetMeasureType('angle')" title="Measure Angle Between Faces"><i class="fas fa-drafting-compass"></i></button>
			<button class="stp-btn" (click)="stpScreenshot()" title="Screenshot"><i class="fas fa-camera"></i></button>

			<span class="stp-sep"></span>

			<button class="stp-view-btn" (click)="stpSetView('front')" title="Front">F</button>
			<button class="stp-view-btn" (click)="stpSetView('back')" title="Back">B</button>
			<button class="stp-view-btn" (click)="stpSetView('top')" title="Top">T</button>
			<button class="stp-view-btn" (click)="stpSetView('bottom')" title="Bottom">Bt</button>
			<button class="stp-view-btn" (click)="stpSetView('left')" title="Left">L</button>
			<button class="stp-view-btn" (click)="stpSetView('right')" title="Right">R</button>
			<button class="stp-view-btn" (click)="stpSetView('iso')" title="Iso">Iso</button>

			<span class="stp-sep"></span>

			<select class="stp-material" [(ngModel)]="selectedMaterialName" (change)="onMaterialChanged()" title="Estimate mass from material density">
				<option value="">Material…</option>
				<option *ngFor="let m of materials" [value]="m.name">{{ m.name }}</option>
			</select>

			<span class="stp-dimensions" *ngIf="stpDimensions">{{ stpDimensions }}</span>
			<span class="stp-info" *ngIf="stpSurfaceArea">SA: {{ stpSurfaceArea }}</span>
			<span class="stp-info" *ngIf="stpVolume">Vol: {{ stpVolume }}</span>
			<span class="stp-info stp-mass" *ngIf="stpMass">Mass: {{ stpMass }}</span>
			<span class="stp-measure-result" *ngIf="stpMeasureResult">{{ stpMeasureResult }}</span>
		</div>

		<!-- Section panel (top-right of viewer when active) -->
		<div class="stp-panel stp-section-panel" *ngIf="stpSectionVisible">
			<div class="stp-panel-title">Section Plane</div>
			<div class="stp-panel-row">
				<button class="stp-mini-btn" [class.active]="stpSectionAxis === 'x'" (click)="stpSetSectionAxis('x')">X</button>
				<button class="stp-mini-btn" [class.active]="stpSectionAxis === 'y'" (click)="stpSetSectionAxis('y')">Y</button>
				<button class="stp-mini-btn" [class.active]="stpSectionAxis === 'z'" (click)="stpSetSectionAxis('z')">Z</button>
				<button class="stp-mini-btn" [class.active]="stpSectionInverted" (click)="stpInvertSection()" title="Invert side"><i class="fas fa-exchange-alt"></i></button>
			</div>
			<input type="range" min="0" max="100" step="0.5" [(ngModel)]="stpSectionPosition" (input)="stpUpdateSection()" class="stp-section-slider">
			<div class="stp-panel-row stp-panel-row-tight">
				<span class="text-muted small">{{ stpSectionPosition | number:'1.0-0' }}%</span>
				<button class="stp-mini-btn ms-auto" (click)="stpToggleSection()">Close</button>
			</div>
		</div>

		<!-- Compare panel (top-right under section panel when active) -->
		<div class="stp-panel stp-compare-panel" *ngIf="stpCompareMode" [class.stp-panel-stacked]="stpSectionVisible">
			<div class="stp-panel-title">Compare</div>
			<div class="stp-panel-row">
				<input type="checkbox" [checked]="stpFileAVisible" (change)="stpToggleFileAVisible()">
				<span class="stp-compare-swatch" [style.background]="'#4488cc'"></span>
				<span class="text-muted small">File A (original)</span>
			</div>
			<div class="stp-panel-row">
				<input type="checkbox" [checked]="stpFileBVisible" (change)="stpToggleFileBVisible()">
				<span class="stp-compare-swatch" [style.background]="'#ff8c42'"></span>
				<span class="text-muted small">File B (revision)</span>
			</div>
			<div class="stp-panel-row stp-panel-row-tight">
				<span class="text-muted small me-2">Opacity</span>
				<input type="range" min="0.1" max="1" step="0.05" [(ngModel)]="stpCompareOpacity" (input)="stpUpdateCompareOpacity()" class="stp-section-slider">
			</div>
			<div class="stp-panel-row stp-panel-row-tight">
				<button class="stp-mini-btn ms-auto" (click)="clearCompare()">Exit</button>
			</div>
		</div>

		<!-- Parts panel (left side of viewer when active) -->
		<div class="stp-panel stp-parts-panel" *ngIf="stpPartTreeVisible">
			<div class="stp-panel-title">Parts ({{ stpParts.length }})</div>
			<div class="stp-parts-list">
				<div *ngFor="let part of stpParts" class="stp-part-row">
					<input type="checkbox" [checked]="part.visible" (change)="stpTogglePartVisible(part)">
					<span class="stp-part-name" [title]="part.name">{{ part.name }}</span>
					<button class="stp-mini-btn stp-mini-btn-tight" (click)="stpIsolatePart(part)" title="Isolate"><i class="fas fa-eye"></i></button>
				</div>
			</div>
			<div class="stp-panel-row stp-panel-row-tight">
				<button class="stp-mini-btn" (click)="stpShowAllParts()">Show All</button>
				<button class="stp-mini-btn ms-auto" (click)="stpTogglePartTree()">Close</button>
			</div>
		</div>

		<div #viewerContainer class="cad-viewer-container"></div>
	</div>
</ng-template>

<ng-container *ngIf="embedded; else popupMode">
	<ng-container *ngTemplateOutlet="viewerBody"></ng-container>
</ng-container>

<ng-template #popupMode>
	<dx-popup [width]="'80vw'" [height]="'80vh'" [showTitle]="true" [title]="title" [dragEnabled]="true" [closeOnOutsideClick]="true" [showCloseButton]="true" container=".dx-viewport" [(visible)]="visible">
		<ng-container *ngTemplateOutlet="viewerBody"></ng-container>
	</dx-popup>
</ng-template>
